import React, { useState, useEffect } from 'react';

const StickyOrderButton = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-green-500 to-green-600 text-white py-4 px-4 shadow-2xl z-50 animate-slide-up">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div>
              <p className="font-bold text-lg">🔥 Limited Offer: ₹1,999 Only</p>
              <p className="text-sm text-green-100">Only 23 kits left - Order now!</p>
            </div>
            <button
              onClick={onClick}
              className="bg-white text-green-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-bold transition-all transform hover:scale-105"
              data-testid="sticky-order-button"
            >
              ORDER NOW
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default StickyOrderButton;